import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaQuestionCircle, FaChevronDown } from 'react-icons/fa';

const FAQs = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "Where is Navyaa – The Homestay located?",
      answer: "Navyaa – The Homestay is centrally located in Laxmi Nagar, Nagpur, offering easy access to hospitals, wedding venues, business hubs, and key city areas."
    },
    {
      question: "What type of accommodation do you offer?",
      answer: "We offer fully furnished service apartments and independent rooms designed for short and long stays."
    },
    {
      question: "Who is Navyaa – The Homestay ideal for?",
      answer: "Our homestay is ideal for wedding guests, corporate professionals, families accompanying patients, and tourists seeking extended stays."
    },
    {
      question: "How many apartments are available?",
      answer: "Navyaa – The Homestay features a total of four thoughtfully designed service apartments with different occupancy options."
    },
    {
      question: "Is the stay suitable for long-term accommodation?",
      answer: "Yes. Our service apartments are well suited for long stays, offering privacy, flexibility, and essential amenities."
    },
    {
      question: "Do the apartments have a kitchen?",
      answer: "Yes. Guests have access to a fully equipped kitchen and dining area."
    },
    {
      question: "Are housekeeping services provided?",
      answer: "Yes. Regular housekeeping is provided to ensure a clean and well-maintained living space."
    },
    {
      question: "Is EV charging point available?",
      answer: "Yes. Paid EV charging point is available for guests staying at the property."
    },
    {
      question: "How can I make a booking?",
      answer: "You can book your stay by calling us directly or reaching out via WhatsApp for availability and assistance."
    },
    {
      question: "Is the homestay family-friendly?",
      answer: "Absolutely. Navyaa – The Homestay is designed to be safe, welcoming, and suitable for families of all sizes."
    }
  ];

  return (
    <section className="section-padding bg-gradient-to-b from-white to-primary-50">
      <div className="max-w-4xl mx-auto">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <motion.div
            animate={{ rotate: [0, 10, -10, 10, 0] }}
            transition={{ duration: 3, repeat: Infinity }}
            className="inline-block mb-4"
          >
            <FaQuestionCircle className="text-primary-500 text-5xl mx-auto" />
          </motion.div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <div className="w-24 h-1 bg-primary-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Got questions? We've got answers! Find everything you need to know about your stay.
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.05 }}
              className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-primary-50 transition-colors"
              >
                <span className="font-semibold text-gray-900 pr-4">{faq.question}</span>
                <motion.div
                  animate={{ rotate: openIndex === index ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="text-primary-500 flex-shrink-0"
                >
                  <FaChevronDown size={20} />
                </motion.div>
              </button>

              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

        {/* Still Have Questions */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ delay: 0.8 }}
          className="mt-12 bg-gradient-to-r from-primary-500 to-nature-leaf text-white rounded-2xl p-8 text-center"
        >
          <h3 className="text-2xl font-bold mb-3">Still Have Questions?</h3>
          <p className="mb-6">
            Can't find what you're looking for? We're here to help!
          </p>
          <a 
            href="#contact" 
            className="bg-white text-primary-600 hover:bg-primary-50 px-8 py-3 rounded-full font-bold inline-block transition-all hover:scale-105"
          >
            Contact Us
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQs;
